<div>
  <div id="sidebar-accordion" class="accordion col-md-12">
    <div class="list-group" matTooltip="Menú">
      <a href="#menu-items" aria-label="Menú, seleccione una opción" data-toggle="collapse" aria-expanded="false"
        class="list-group-item list-group-item-action bg-light text-grey sidebarSena" (click)="estado()">
        <i class="fas fa-bars"></i>
      </a>
      <div id="menu-items" class="collapse show" data-parent="#sidebar-accordion">
        <div *ngFor="let i of opciones; let per = index">
          <div class="row mb-3" *ngIf="i.permiso" (click)="collapseButton(i)">
            <div class="col-md-11">
              <div class="row activeOption">
                <div class="col-xs-6 text-right">
                  <i  [ngClass]="i.icono" class="md-18" *ngIf="!i.opciones"></i>
                  <i  [ngClass]="i.icono" *ngIf="i.opciones"></i>
                </div>
                <div class="col-xs-6 mt-1 pl-2">
                  <a [routerLink]="[i.path]" *ngIf="!i.opciones" (click)="colapsar()"  role="button" routerLinkActive="router-link-active"
                    [ngClass]="{disabledMenu:  i.idSegAccion == 14  ||i.idSegAccion == 29  || i.idSegAccion == 21}">{{i.nombre}}</a>
                  <a *ngIf="i.opciones" data-toggle="collapse" [href]="'#c'+per" role="button" aria-expanded="false"
                    aria-controls="collapse1"> {{i.nombre}} </a>
                  <ul *ngIf="i.opciones" class="collapse list-unstyled " [id]="'c'+per">

                    <li *ngFor="let itemOp of i.opciones">
                      <a [routerLink]="[itemOp.path]"
                      (click)="colapsar()" (click)="focusSubmenu()"
                        [ngClass]="{disabledMenu: itemOp.idSegAccion == 22 || itemOp.idSegAccion == 23 || itemOp.idSegAccion == 25 || itemOp.idSegAccion == 26 || itemOp.idSegAccion == 27 || itemOp.idSegAccion == 28 || itemOp.idSegAccion == 31  || itemOp.idSegAccion == 32 }">
                        <i [ngClass]="i.icono"></i>{{itemOp.nombre}}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
